(function (w, d, $) {
	var $w = $(w);
	var $d = $(d);
	var $b;
	
	$(function () {
		$b = $('body');
	});
	
	$.fn.toggleAttr = function(attr) {
		return $(this).attr(attr, function (i, innerAttr) {
			return innerAttr === 'true' ? 'false' : 'true';
		});
	};
	
	// Burger and menu
	$(function () {
		var $header = $('header');
		$d.on('click', '.burger', function() {
			$b.toggleClass('header-open');
			$header.toggleClass('header-open');
			$(this).toggleAttr('aria-expanded');
		});
	});
	
	// Scrolling
	$(function() {
		var lastScroll = 0;
		var $header = $('header');
		$w.on('scroll', function() {
			var currentScroll = $w.scrollTop();
			$header.toggleClass('header-scrolled', (currentScroll > 100));
			$header.toggleClass('header-scrolling-up', (currentScroll < lastScroll));
			lastScroll = currentScroll;
		});
	});
	
	// Flex Blog
	$(function() {
		var leftArrow = '<svg xmlns="http://www.w3.org/2000/svg" width="22.239" height="16.795" viewBox="0 0 22.239 16.795"><g id="Group_5838" data-name="Group 5838" transform="translate(1.103 0.55)"><path id="Path_20783" data-name="Path 20783" d="M-347.654,3132.89l-8.46-7.848,8.46-7.848" transform="translate(356.114 -3117.195)" fill="none" stroke="#333" stroke-miterlimit="10" stroke-width="1.5"/><line id="Line_14" data-name="Line 14" x1="21.136" transform="translate(0 7.848)" fill="none" stroke="#333" stroke-miterlimit="10" stroke-width="1.5"/></g></svg>';
		var rightArrow = '<svg xmlns="http://www.w3.org/2000/svg" width="22.239" height="16.795" viewBox="0 0 22.239 16.795"><g id="Group_5838" data-name="Group 5838" transform="translate(0 0.55)"><path id="Path_20783" data-name="Path 20783" d="M-356.114,3132.89l8.46-7.848-8.46-7.848" transform="translate(368.79 -3117.195)" fill="none" stroke="#333" stroke-miterlimit="10" stroke-width="1.5"/><line id="Line_14" data-name="Line 14" x2="21.136" transform="translate(0 7.848)" fill="none" stroke="#333" stroke-miterlimit="10" stroke-width="1.5"/></g></svg>';

		$('.flex-blog .blogs').addClass('owl-carousel').owlCarousel({
			items: 1,
			lazyLoadEager: 1,
			loop: true,
			dots: false,
			autoplay: false,
			nav: true,
			navText: [leftArrow, rightArrow],
			navElement: 'div',
		});
	});
	
	// animate widths of horiz line
	$(function() {
		var $el = $('.horiz-line');
		if(!$el.length) {
			return;
		}
		var wHeight = $w.height();
		var percent = 0;
		var update = function() {
			$el.css('width', percent + '%');
		};

		$w.on('scroll', function() {
			var scrollTop = $w.scrollTop();
			var elementOffset = $el.offset().top;
			var distance = (elementOffset - scrollTop);
			var elementScrollInSreen = wHeight - distance;

			

			if(elementScrollInSreen >= 0 && elementScrollInSreen < (wHeight * 0.8)) {
				percent = Math.min(elementScrollInSreen / (wHeight * 0.5) * 100, 100);
				w.requestAnimationFrame(update);
			}
		});
	});

	// Timeline - Animate vertical line
	$(function() {
		var $el = $('.flex-timeline .processes-line');
		if(!$el.length) {
			return;
		}
		var wHeight = $w.height();
		var eHeight = $el.height();
		var pixelHeight = 0;
		var update = function() {
			$el.css('height', pixelHeight + 'px');
		};

		$w.on('scroll', function() {
			var scrollTop = $w.scrollTop();
			var elementOffset = $el.offset().top;
			var newHeight = scrollTop + wHeight - (wHeight * 0.4) - elementOffset;
			newHeight = (Math.round(newHeight * 10) / 10);
			newHeight = Math.min(newHeight, eHeight);
			
			if(Math.abs(newHeight - pixelHeight) < 0.5) {
				return;
			}

			pixelHeight = newHeight;
			w.requestAnimationFrame(update);
		});
	});

	// Flex Content Carousel
	$(function() {
		var leftArrow = '<svg xmlns="http://www.w3.org/2000/svg" width="22.239" height="16.795" viewBox="0 0 22.239 16.795"><g id="Group_5838" data-name="Group 5838" transform="translate(1.103 0.55)"><path id="Path_20783" data-name="Path 20783" d="M-347.654,3132.89l-8.46-7.848,8.46-7.848" transform="translate(356.114 -3117.195)" fill="none" stroke="#24c27b" stroke-miterlimit="10" stroke-width="1.5"/><line id="Line_14" data-name="Line 14" x1="21.136" transform="translate(0 7.848)" fill="none" stroke="#24c27b" stroke-miterlimit="10" stroke-width="1.5"/></g></svg>';
		var rightArrow = '<svg xmlns="http://www.w3.org/2000/svg" width="22.239" height="16.795" viewBox="0 0 22.239 16.795"><g id="Group_5838" data-name="Group 5838" transform="translate(21.136 16.245) rotate(180)"><path id="Path_20783" data-name="Path 20783" d="M-347.654,3132.89l-8.46-7.848,8.46-7.848" transform="translate(356.114 -3117.195)" fill="none" stroke="#24c27b" stroke-miterlimit="10" stroke-width="1.5"/><line id="Line_14" data-name="Line 14" x1="21.136" transform="translate(0 7.848)" fill="none" stroke="#24c27b" stroke-miterlimit="10" stroke-width="1.5"/></g></svg>';

		$('.flex-contentcarousel .carousel').addClass('owl-carousel').owlCarousel({
			items: 3,
			lazyLoadEager: 1,
			loop: true,
			dots: false,
			autoplay: false,
			nav: true,
			navText: [leftArrow, rightArrow],
			navElement: 'div',
			margin: 15,
		});
	});

	// Animation classes
	$(function() {
		if(!window.IntersectionObserver) {
			return;
		}

		var observer = new IntersectionObserver(function handleIntersection(entries) {
			entries.map(function(entry) {
				if (entry.isIntersecting) {
					entry.target.classList.add('animated');
				}
			});
		}, {rootMargin: '0px 0px 0px 0px'});
		document.querySelectorAll('.animate').forEach(function(target) {
			observer.observe(target);
		});
	});

	// Flex Team
	$(function() {
		// Filtering
		var filteredIds = [];
		$d.on('click', '.flex-team .team-category', function() {
			if($(this).hasClass('team-category-active')) {
				return;
			}

			// category buttons
			$('.flex-team .team-category.team-category-active').removeClass('team-category-active');
			$(this).addClass('team-category-active');

			// team members
			filteredIds = [];
			$('.flex-team .team-category.team-category-active').each(function()  {
				filteredIds.push(parseInt($(this).attr('data-term-id')));
			});

			// filter here
			if(filteredIds.length === 1 && filteredIds[0] === 0) {
				$('.flex-team .team-member').removeClass('team-member-hidden');
				return;
			}
			$('.flex-team .team-member').each(function() {
				var $teamMember = $(this);

				var termIds = $teamMember.attr('data-term-ids').split(',').map(function(id) {
					return parseInt(id);
				});

				var allIntersect = true;
				filteredIds.forEach(function(id) {
					allIntersect &= (termIds.indexOf(id) >= 0);
				});

				$teamMember.toggleClass('team-member-hidden', !allIntersect);
			});
			$('.flex-team .team-members-none').css('display', ($('.flex-team .team-member:not(.team-member-hidden)').length ? 'none' : 'block'));
		});

		// Overlay
		$d.on('click', '.flex-team .team-member', function() {
			if($(this).hasClass('team-member-disable-modal')) {
				return;
			}
			
			$(this).addClass('team-member-showing');
		});

		$d.on('click', '.flex-team .team-member .overlay-close', function(e) {
			e.stopPropagation();
			$(this).closest('.team-member').removeClass('team-member-showing');
		});	

		// Overlay click close
		$d.on('click', '.flex-team .team-member .team-member-overlay', function(e) {
			e.stopPropagation();
			$(this).closest('.team-member').removeClass('team-member-showing');
		});	
		// Stop every click on overlay closing from above
		$d.on('click', '.flex-team .team-member .overlay-background', function(e) {
			e.stopPropagation();
		});	
	});

	// Make fixed BG images absolute when we go past them so that 
	// they don't bleed through when the user scrolls down the screen
	$(function() {
		if(!window.IntersectionObserver) {
			return;
		}

		if($w.width() <= 767) {
			return;
		}

		var observer = new IntersectionObserver(function handleIntersection(entries) {
			// Some reason this intersection observer was firing on page load a 0px
			if($(window).scrollTop() <= 100) {
				return;
			}
			entries.map(function(entry) {
				if (entry.isIntersecting) {
					entry.target.querySelector('.background-image').style.position = 'fixed';
				} else {
					entry.target.querySelector('.background-image').style.position = 'absolute';
				}
			});
		}, {rootMargin: '0px 0px -70% 0px'});
		document.querySelectorAll('.flex.flex-heroextended').forEach(function(target) {
			observer.observe(target);
		});
	});


	// autoheight 
	$(function () {
		var resizeEventName = 'ABGF.autoHeight';

		if ($w.width() < 768) {
			return;
		}

		$d.on(resizeEventName, function () {
			[
				'.flex-contentcolspullout .columns .column .image',
				'.flex-contentcolspullout .columns .column .col-title',
				'.flex-contentcolspullout .columns .column .copy',
				'.flex-contenticoncols .columns .column .image',
			].forEach(function(selector) {

				var $el = $(selector);
				var headingHeight = 0;
	
				$el.each(function (j, el) {
					headingHeight = Math.max($(el).outerHeight(), headingHeight);
				});
	
				$el.css('min-height', headingHeight + 'px');
			});
		});

		// run on load and when browser resizes
		$d.trigger(resizeEventName);
		setTimeout(function () {
			$d.trigger(resizeEventName);
		}, 100);
		$w.on('resize', function () {
			$d.trigger(resizeEventName);
		});
	});

	// Add class to GF select if it has been changed to not be the placeholder
	$(function () {
		$d.on('change', 'select', function() {
			var isPlaceHolderSelected = $(this).find('option:selected').hasClass('gf_placeholder');
			$(this).toggleClass('select-chosen', !isPlaceHolderSelected);
		});
	});

	// archive-insight
	// tags, categories, search, pagination and AJAX
	$(function () {
		if($('body.post-type-archive').length <= 0) {
			return;
		}

		var $main = $('main');

		// main state
		var state = {
			search: null,
			tags: [],
			category: null,
			paged: 1,
			cpt: $('#cpt').val(),
		};

		// category
		$d.on('change', '#categories select', function() {
			state.category = $(this).val();
			state.paged = 1;
			getPosts();
		});

		// search
		$d.on('click', '.search button', function() {
			state.search = $('.search').find('input').val();
			getPosts();
		});
		$d.on('click', '#search-results-clear', function() {
			state.search = '';
			state.paged = 1;
			$('.search input').val('');

			getPosts();
		});

		// load more paged
		$d.on('click', '#load-more button', function() {
			state.paged ++;
			getPosts();
		});
		
		// tags 
		// opening/closing
		$d.on('click', '#tags-arrow, #tags-inner .tag-placeholder', function() {
			$('#tags').toggleClass('tags-open');
		});
		// toggle activity
		$d.on('click', '#tags-inner .tag', function() {
			var $tag = $(this).toggleClass('tag-active');
			var isNowActive = $tag.hasClass('tag-active');
			var id = parseInt($tag.attr('data-tag-id'));

			// update the state
			if(isNowActive) {
				state.tags.push(id);
			} else {
				state.tags = state.tags.filter(function(tag) {
					return tag !== id;
				});

				$tag.blur();
			}
			state.paged = 1;

			// sort them
			var $newTags = $('#tags-inner .tag').sort(function(a, b) {
				return $(b).hasClass('tag-active') - $(a).hasClass('tag-active');
			});
			// replace them
			$('#tags-inner .tag').remove();
			$('#tags-inner').append($newTags);

			// Set the empty selection class
			$('#tags').toggleClass('tags-filled', (state.tags.length > 0));

			getPosts();
		});

		// get new posts
		function getPosts() {
			$main.fadeTo(300, 0.6);

			$.ajax({
				url: window.abgf.ajaxUrl + '?action=GetPosts',
				method: 'POST',
				data: state,
			}).then(function (res) {
				if(!res.success) {
					return alert('There was an error, please try again.');
				}

				//replace posts
				if(state.paged > 1) {
					if(res.data.posts.length <= 0) {
						$('#load-more').addClass('load-more-none');
					} else {
						$('.view-archive-posts .posts').append($(res.html).find('.post'));
					}
				} else {
					$('.view-archive-posts').replaceWith(res.html);
				}

				// handle search results notices
				var $searchResults = $('#search-results');
				
				if(res.data.search) {
					$searchResults.removeClass('search-results-none');
					
					if(res.data.posts.length) {
						$('#search-results-count').html(res.data.posts.length);
					} else {
						$('#search-results-count').html('No');
					}

					$('#search-results-plural').toggle(res.data.posts.length !== 1);
				} else {
					$searchResults.addClass('search-results-none');
				}
				$('#search-results-term').html(res.data.search);
			}, function (err) {
				console.log(err);
				return alert('There was an error, please try again.');
			}).always(function() {
				$main.fadeTo(100, 1);
			});
		}
	});

	$(function () {
		var formId = '5338a006-4518-ed11-b83e-00224891ea93';
		var $form;

		function validateSubmit() {
			var allValid = true;
			$form.find('input[type="text"], input[type="email"]').each(function() {
				var $input = $(this);
				var valid = !!$input.val();

				if($input.attr('type') === 'email') {
					valid = $input[0].checkValidity();
				}

				allValid &= valid;
			});

			var $button = $form.find('button[type="submit"]');
			if(allValid) {
				$button.removeAttr('disabled');
			} else {
				$button.attr('disabled', 'disabled');
			}
		}

		if(!window.MsCrmMkt || !window.MsCrmMkt.MsCrmFormLoader) {
			return;
		}

		window.MsCrmMkt.MsCrmFormLoader.on('afterFormLoad', function(e) {
			if(e.formPageId !== formId) {
				return;
			}

			$form = $('[data-form-block-id="'+formId+'"] form');
			validateSubmit();

			$form.find('input[type="text"], input[type="email"]').on('blur', function() {
				var $input = $(this);
				var valid = !!$input.val();
				if($input.attr('type') === 'email') {
					valid = $input[0].checkValidity();
				}

				$input
					.closest('.lp-form-field')
					.addClass('touched')
					.toggleClass('valid', valid)
					.toggleClass('invalid', !valid);

				validateSubmit();
			});

			$form.find('input[type="text"], input[type="email"]').on('keydown', function() {
				validateSubmit();
			});
		});

		window.MsCrmMkt.MsCrmFormLoader.on('formSubmit', function(e) {
			if(e.formPageId !== formId) {
				return;
			}
			$form.addClass('loading');
		});

		window.MsCrmMkt.MsCrmFormLoader.on('afterFormSubmit', function(e) {
			if(e.formPageId !== formId) {
				return;
			}

			$('[data-form-block-id="'+e.formPageId+'"] .onFormSubmittedFeedbackIcon').attr('src', "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='47' height='48' viewBox='0 0 47 48'%3E%3Cg id='Group_49318' data-name='Group 49318' transform='translate(20678.5 4328.063)'%3E%3Cpath id='Path_163106' data-name='Path 163106' d='M8266-10610.182l8.25,8.248,16.9-16.9' transform='translate(-28932.316 6306.32)' fill='none' stroke='%2324c27b' stroke-width='2'/%3E%3Cg id='Ellipse_365' data-name='Ellipse 365' transform='translate(-20678.5 -4328.063)' fill='none' stroke='%23333' stroke-width='2'%3E%3Cellipse cx='23.5' cy='24' rx='23.5' ry='24' stroke='none'/%3E%3Cellipse cx='23.5' cy='24' rx='22.5' ry='23' fill='none'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A");
		});
	});

	// Flex Portfolio
	$(function () {
		var $current = $d.find('.select-custom-current');
		var maxSectorsDisplay = 2;
		var filter = [];
		var $portfolios = $('section.flex-portfolio .portfolios article');

		$b.on('click', function() {
			$b.removeClass('select-custom-open');
			$('section.flex-portfolio').removeClass('select-custom-open');
			$('section.flex-portfolio .select-custom').removeClass('select-custom-open');
		});

		$d.find('section.flex-portfolio .select-custom').on('click', function(e) {
			e.stopPropagation();
		});

		$d.find('section.flex-portfolio .select-custom-current-container').on('click', function() {
			$b.toggleClass('select-custom-open');
			$(this).closest('section').toggleClass('select-custom-open');
			$(this).closest('.select-custom').toggleClass('select-custom-open');
		});

		$d.find('section.flex-portfolio .select-custom li').on('click', function() {
			$(this).toggleClass('active');

			filter = $(this).closest('ul').find('li.active').map(function() {
				return parseInt($(this).attr('data-term-id'));
			}).get();
			
			var selected = $(this).closest('ul').find('li.active span').map(function() {
				return $(this).text();
			}).get();

			var text = '';
			if(selected.length <= 0) {
				text = 'All sectors';
			} else if(selected.length <= maxSectorsDisplay) {
				text = selected.join(', ');
			} else {
				var others = selected.length - maxSectorsDisplay;
				var plural = others > 1 ? 's' : '';
				text = selected.slice(0, maxSectorsDisplay).join(', ') + ', (+' + others + ' other' + plural + ')';
			}

			$current.text(text);

			if(filter.length <= 0) {
				return $portfolios.show();
			}

			$portfolios.each(function(_i, p) {
				var $p = $(p);
				var pSectors = $p.attr('data-sectors');
				if(!pSectors) {
					$p.hide();
				}

				var portfolioTermIds = JSON.parse(pSectors);
				var intersect = portfolioTermIds.filter(function(id) {
					return filter.includes(id);
				});

				if(intersect.length > 0) {
					$p.show();
				} else {
					$p.hide();
				}
			});
		});
	});
})(window, document, window.jQuery); 